import { useMutation, useQuery } from "./helper";
import { getCompanyLogo, updateCompanyLogo } from "../../../api/company";

type CompanyLogoUpdateVariables = {
    companyId: number | string;
    payload: FormData;
};

export const useCompanyLogo = (companyId, options) => useQuery<Blob>({
    queryKey: ['company-logo', companyId],
    queryFn: () => getCompanyLogo(companyId),
    isBlob: true,
    ...options,
});

export const useCompanyLogoUpdate = () => useMutation<
    unknown,
    Error,
    CompanyLogoUpdateVariables
>({
    mutationFn: ({ companyId, payload }) => updateCompanyLogo(companyId, payload),
});
